import { useState } from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';

import { useGiftCardCheckoutValidation } from '../../../hooks/use-gift-card-checkout-validation';
import { usePaymentFlowStore } from '../../../state/payment-stores/payment-flow-store';
import GiftCardReloadActionSheetWrapper from '../gift-card-reload-action-sheet';
import PlaceOrderButton from '../place-order-button';
import ReloadGiftCardButton from '../reload-gift-card-button';

export default function CheckoutActionButton() {
  const [showGiftCardReloadAndPayActionSheet, setShowGiftCardReloadAndPayActionSheet] =
    useState(false);

  const { showReloadGiftCardCTA } = useGiftCardCheckoutValidation();
  
  // Show PlaceOrderButton when pipeline is processing (e.g., after gift card reload)
  // This prevents showing the Reload CTA while the order is being committed
  const currentState = usePaymentFlowStore(state => state.currentState);
  const isPipelineProcessing = currentState !== 'idle' && currentState !== 'success' && currentState !== 'error';
  
  const shouldShowReloadCTA = showReloadGiftCardCTA && !isPipelineProcessing;

  return (
    <>
      <SafeAreaView>
        {shouldShowReloadCTA ? (
          <ReloadGiftCardButton onPress={() => setShowGiftCardReloadAndPayActionSheet(true)} />
        ) : (
          <PlaceOrderButton />
        )}
      </SafeAreaView>

      <GiftCardReloadActionSheetWrapper
        isOpen={showGiftCardReloadAndPayActionSheet}
        onClose={() => setShowGiftCardReloadAndPayActionSheet(false)}
      />
    </>
  );
}
